import { Link } from "react-router-dom";
import { STUDIO } from "@/lib/site";
export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#DAE3D2] border-t border-[#CFD9C5] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="font-serif-elegant text-2xl text-[#3D3B3A]">{STUDIO.name}</p>
            <p className="eyebrow mt-2">Ascolto · Consapevolezza · Equilibrio</p>
            <p className="mt-6 text-sm text-[#73706E] max-w-md leading-relaxed">
              Studio di psicologia, sessuologia clinica e comunicazione ipnotica.
              Un luogo di benessere discreto a Chivasso.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow">Navigazione</p>
            <ul className="mt-5 space-y-3 text-sm text-[#3D3B3A]">
              <li><Link to="/chi-sono" className="hover:text-[#7E9C7B]" data-testid="footer-link-about">Chi sono</Link></li>
              <li><Link to="/servizi" className="hover:text-[#7E9C7B]" data-testid="footer-link-services">Servizi</Link></li>
              <li><Link to="/prenota" className="hover:text-[#7E9C7B]" data-testid="footer-link-booking">Prenota</Link></li>
              <li><Link to="/faq" className="hover:text-[#7E9C7B]" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contatti" className="hover:text-[#7E9C7B]" data-testid="footer-link-contact">Contatti</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow">Studio</p>
            <ul className="mt-5 space-y-3 text-sm text-[#3D3B3A]">
              <li>{STUDIO.address}, {STUDIO.city}</li>
              <li><a href={`tel:${STUDIO.phoneRaw}`} className="hover:text-[#7E9C7B]">{STUDIO.phone}</a></li>
              <li><a href={`mailto:${STUDIO.email}`} className="hover:text-[#7E9C7B]">{STUDIO.email}</a></li>
              <li className="text-[#73706E]">{STUDIO.domain}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#9DB39A]/30 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#73706E]">
          <p>© {new Date().getFullYear()} Dott.ssa Chiara Maiolo — Tutti i diritti riservati.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#7E9C7B]">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-link-cookie" className="hover:text-[#7E9C7B]">Cookie Policy</Link>
            <span>P.IVA: {STUDIO.vat}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
